module.exports = __webpack_public_path__ + "img/image50.a21ea81d.jpg";